export default "__VITE_ASSET__b134ea04__"